import React from 'react'
import PropTypes from 'prop-types'

import Card from '@components/card'

import colors from '@settings/styleSettings'

import { ButtonOption, Divisor } from './styles'

const ModalOptions = ({
  isOpenLoan, onShowTerm, setShowDevolutionModal
}) => {

  return (
    <Card
      style={{
        width: '150px',
        height: isOpenLoan ? '80px' : '40px',
        padding: '0px',
        alignItems: 'flex-start',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        border: `1pt ${colors.softGray} solid`,
      }}
    >
      <ButtonOption onClick={onShowTerm}>
        Visualizar Termo
      </ButtonOption>
      {isOpenLoan && (
        <>
          <Divisor />
          <ButtonOption onClick={setShowDevolutionModal}>
            Registrar Devolução
          </ButtonOption>
        </>
      )}
    </Card>
  )
}

ModalOptions.propTypes = {
  isOpenLoan: PropTypes.bool,
  onShowTerm: PropTypes.func.isRequired,
  setShowDevolutionModal: PropTypes.func,
}

ModalOptions.defaultProps = {
  isOpenLoan: false,
  setShowDevolutionModal: null,
}

export default ModalOptions
